<div class="container">
  <canvas #main [ngStyle]="{'margin': 0}"></canvas>
</div>



